import { ReactNode } from 'react';

export enum AlertType {
  Error = 'error',
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
}

export type AlertProps = {
  duration?: number;
  isClickAwayDisabled?: boolean;
  isOpen: boolean;
  message: ReactNode;
  type?: AlertType;
};
